var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4D54F3;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_582",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_ar_2300882",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1308"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,71.7c-0.4-0.9-1.6-1.3-2.5-0.9l-10.1,5V63.9c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9v11.9 l-10.1-5.1c-0.3-0.1-0.5-0.2-0.8-0.2c-0.7,0-1.4,0.4-1.7,1.1c-0.2,0.5-0.2,1-0.1,1.4c0.2,0.5,0.5,0.9,1,1.1l12.7,6.4 c0.6,0.3,1.2,0.3,1.8,0l12.7-6.4C50.6,73.6,51,72.6,50.6,71.7z M49.8,6.9L37,0.5c-0.5-0.3-1.2-0.3-1.8,0L22.5,7 c-0.9,0.5-1.3,1.6-0.8,2.5c0.5,0.9,1.6,1.3,2.5,0.8l10.1-5v11.9c0,1,0.8,1.9,1.9,1.9c1,0,1.9-0.8,1.9-1.9V5.2l10.1,5 c0.9,0.4,2,0.1,2.5-0.8C51,8.5,50.7,7.4,49.8,6.9z M16.7,13.4c0.1-0.5,0.1-1-0.1-1.4c-0.3-0.6-1-1-1.7-1c-0.3,0-0.6,0.1-0.9,0.2 L1.3,17.5c-0.7,0.3-1.1,1-1.1,1.7v14.9c0,1,0.8,1.9,1.9,1.9c1,0,1.9-0.8,1.9-1.9V22.3l10.1,5c0.9,0.4,2,0.1,2.5-0.8 c0.5-0.9,0.1-2.1-0.8-2.5l-9.4-4.7l9.5-4.8C16.2,14.3,16.6,13.9,16.7,13.4z M16.7,67.5c-0.2-0.5-0.5-0.8-1-1l-9.4-4.7l9.5-4.8 c0.4-0.2,0.8-0.6,0.9-1.1c0.1-0.5,0.1-1-0.1-1.4c-0.5-0.9-1.6-1.3-2.5-0.8L4,58.8V46.9c0-1-0.8-1.9-1.9-1.9 c-1,0-1.9,0.8-1.9,1.9v14.9c0,0.2,0,0.5,0.1,0.7c0,0,0,0.1,0,0.1l0,0c0.2,0.4,0.5,0.7,0.9,0.8L14,69.9c0.1,0,0.1,0.1,0.2,0.1 c0.9,0.4,2,0,2.5-1C16.9,68.5,16.9,68,16.7,67.5z M72.1,46.9c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9v11.9l-10.1-5 c-0.3-0.1-0.5-0.2-0.8-0.2c-0.7,0-1.3,0.4-1.7,1c-0.5,0.9-0.1,2,0.8,2.5l9.4,4.7l-9.4,4.7C55.7,67,55.4,68,55.8,69 c0.4,0.9,1.6,1.3,2.5,0.9L71,63.5c0.7-0.3,1.1-1,1.1-1.7L72.1,46.9z M72,18.6c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.5-0.7-0.9-0.9 l-12.8-6.4c-0.9-0.4-2-0.1-2.5,0.8c-0.5,0.9-0.1,2.1,0.8,2.5l9.4,4.7l-9.4,4.7c-0.9,0.5-1.2,1.5-0.8,2.5 c0.4,0.9,1.6,1.3,2.5,0.9l10.1-5v11.9c0,1,0.8,1.9,1.9,1.9c0,0,0,0,0,0c0.5,0,1-0.2,1.3-0.5c0.4-0.4,0.6-0.8,0.6-1.3V19.3 C72.1,19,72,18.8,72,18.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "noun_ar_2300882-2",
    transform: "translate(21.281 28.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_580-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1308-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4,1.8c-0.2,0.5-0.5,0.9-0.9,1.1L16.9,8.7l-0.1,0.1v11.6c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.3-0.3,0.5 v0c0,0.1-0.1,0.1-0.1,0.1c-0.3,0.3-0.8,0.5-1.3,0.5c-0.5,0-1-0.2-1.3-0.5c0,0-0.1-0.1-0.1-0.1v0c-0.1-0.1-0.2-0.3-0.3-0.5 C13,20.9,13,20.6,13,20.4V8.8L1.3,2.9C0.9,2.7,0.6,2.4,0.5,2.1c0-0.1-0.1-0.2-0.1-0.4c-0.1-0.3-0.1-0.6,0-0.9 c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0.3-0.6,1-1,1.7-1c0.3,0,0.5,0.1,0.8,0.2l11.9,6l11.9-6c0.2-0.1,0.4-0.1,0.6-0.2 c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0.1c0.5,0.2,0.9,0.5,1.1,0.9C29.5,0.8,29.6,1.3,29.4,1.8z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3D);
export default __webpack_public_path__ + "static/media/_icon_3D.02ad1db9aae53c1460fe2880bcdba004.svg";
export { ForwardRef as ReactComponent };